module.exports = __webpack_public_path__ + "static/about-1-sm-1222994e2f4bbcaf571c3c4f259dcf55.jpg";